import { useEffect, useRef } from 'react';
export const useFocusModuleInspector = ({ refs, onFocusModuleChange, }) => {
    const lastScrollY = useRef(0);
    useEffect(() => {
        const handleScroll = () => {
            const viewportCenterY = window.innerHeight / 2;
            const currentScrollY = window.scrollY;
            const isScrollingDown = currentScrollY > lastScrollY.current;
            lastScrollY.current = currentScrollY;
            let newFocusModule = null;
            refs.forEach((ref, index) => {
                const rect = ref.getBoundingClientRect();
                if (isScrollingDown) {
                    if (rect.bottom > viewportCenterY && rect.top < viewportCenterY) {
                        newFocusModule = ref;
                    }
                }
                else {
                    if (index > 0) {
                        const previousRect = refs[index - 1].getBoundingClientRect();
                        if (previousRect.top < viewportCenterY &&
                            previousRect.bottom > viewportCenterY) {
                            newFocusModule = refs[index - 1];
                        }
                    }
                }
            });
            if (newFocusModule) {
                onFocusModuleChange(newFocusModule);
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => {
            var _a;
            (_a = document.body) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', handleScroll);
        };
    }, [refs, onFocusModuleChange]);
};
